var map = {
	"./BackLink.vue": "0Dz+",
	"./grid/DataGridPaginator.vue": "dcMw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ojfx";


//////////////////
// WEBPACK FOOTER
// ./public/themes/frontend/imbotex/assets/js/theme-components \.vue$/
// module id = ojfx
// module chunks = 0